import {
  type Privileges,
  useCurrentOrganization,
} from '~publish/contexts/AccountContext'

export type Privilege = keyof Omit<Privileges, '__typename'>

export const useHasPrivilege = (privilege: Privilege): boolean => {
  const curentOrganization = useCurrentOrganization()
  return curentOrganization?.privileges?.[privilege] ?? false
}
